import { createAsyncThunk } from "@reduxjs/toolkit";
import { agent, encodeGetParams } from "../../api";
import { apiUrlV1 } from "../../config/config";
import { ApiQueryParams } from "../../entities/global";
import { addNotification } from "../Notification/notificateStore";
import { IReqRules, Rule } from "../../entities/rules";

export const getRules = createAsyncThunk(
  'rules/list',
  async (params?: ApiQueryParams): Promise<IReqRules> => {
    const query = encodeGetParams({ ...params })
    const req = await agent.get(`${apiUrlV1}/organization/game/rules/list${query}`);
    if (req.ok) {
      const res = await req.json() as IReqRules;
      return res;
    }
    return {
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
      data: []
    };
  }
);

export const postRule = createAsyncThunk(
  'rules/post-rule',
  async (params: { data: Rule }, thunksApi) => {
    try {
      const response = await agent.post(`${apiUrlV1}/organization/game/rules`, { body: JSON.stringify(params.data) })
      if (response.ok) {
        addNotification({ status: "success", text: "Successfully saved" })
        thunksApi.dispatch(getRules())
      }
      if (!response.ok) {
        throw Error("No response");
      }
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)

export const patchRule = createAsyncThunk(
  'rules/patch-rule',
  async (params: { data: any, id: number }, thunksApi) => {
    try {
      const response = await agent.patch(`${apiUrlV1}/organization/game/rules/${params.id}`, { body: JSON.stringify(params.data) })
      if (response.ok) {
        addNotification({ status: "success", text: "Successfully saved" })
        thunksApi.dispatch(getRules())
      }
      if (!response.ok) {
        throw Error("No response");
      }
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)

export const deleteRule = createAsyncThunk(
  'rules/delete-rule',
  async (params: { id: number }, thunksApi) => {
    try {
      const response = await agent.delete(`${apiUrlV1}/organization/game/rules/${params.id}`)
      if (response.ok) {
        addNotification({ status: "success", text: "Successfully saved" })
        thunksApi.dispatch(getRules())
      }
      if (!response.ok) {
        throw Error("No response");
      }
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)